<template>
  <vSelect
    v-bind="$attrs"
    v-on="$listeners"
    class="base-select leading-tight text-sm"
    :clearable="clearable"
    :options="options"
    :value="value"
  >
    <template #open-indicator="{attributes}">
      <BaseIcon width="14" height="8" v-bind="attributes" name="arrow-down" />
    </template>
    <template #spinner="{loading}">
      <BaseLoader v-if="loading" size="sm" />
    </template>
    <template #no-options>
      <slot name="no-options">Нет подходящих вариантов</slot>
    </template>
  </vSelect>
</template>

<script>
  import vSelect from 'vue-select';
  import BaseIcon from '@/components/global/base-icon';
  import BaseLoader from '@/components/global/base-loader';

  export default {
    name: 'BaseSelect',

    components: {
      vSelect,
      BaseIcon,
      BaseLoader,
    },

    props: {
      options: {
        type: Array,
        default: () => [],
      },
      clearable: {
        type: Boolean,
        default: false,
      },
      placeholderValue: {
        type: [String, Object],
        default: null,
      },
      value: {
        type: [String, Number, Boolean, Object, Array],
        default: '',
      },
    },

    computed: {
      pluginValue: {
        get() {
          return this.value || this.placeholderValue;
        },
        set(value) {
          if (value !== this.placeholderValue) {
            this.$emit('input', value);
          }
        },
      },
    },
  };
</script>

<style lang="scss">
  .v-select {
    &.vs--single:not(.vs--open) {
      .vs__selected + input[type="search"] {
        border: 0px !important;
        padding: 0px !important;
        margin: 0px !important;
        width: 0px !important;
        height: 0px !important;
      }
    }

    .vs__dropdown-toggle {
      background-color: white;
      border: 1px solid #A7A8AB;
      &:hover {
        border-color: #333333;
      }
    }

    &.vs--open {
      .vs__dropdown-toggle {
        border-color: #333333;
      }
      .vs__dropdown-menu {
        border-color: #333333;

        .vs__dropdown-option {
          word-wrap: break-word;
          text-overflow: inherit;
          white-space: normal;
        }
      }
    }

    &.vs--disabled {
      .vs__dropdown-toggle {
        background-color: #D9D9DE;
      }
      .vs__search {
        background-color: #D9D9DE;
      }
      .vs__actions {
        svg {
          background-color: #D9D9DE;
        }
      }
    }
  }
</style>
